import React, { CSSProperties, ReactNode } from 'react';
import clsx from 'clsx';
import { Modal } from 'react-bootstrap';

// Keeps modal content in a readable centred column rather than letting it span
// the full width of the large dialog.
const CONTENT_COLUMN: CSSProperties = { margin: '0 auto', maxWidth: '510px' };

interface CommonLargeModalProps extends React.PropsWithChildren {
  show: boolean;
  onHide: () => void;
  title?: ReactNode | string;
  // Merged into the always-centred title - use it for the title's typography.
  titleClassName?: string;
  titleStyle?: CSSProperties;
  // Both replace the defaults, for a body that lays itself out (a form, say).
  bodyClassName?: string;
  bodyStyle?: CSSProperties;
  // Fires once the fade-out has finished - the point at which it is safe to
  // unmount the modal or drop the content it was showing.
  onExited?: () => void;
  // Caps the dialog to the viewport height and scrolls the body internally,
  // instead of letting a tall body run off the bottom of a small screen.
  scrollable?: boolean;
}

const CommonLargeModal = ({
  children,
  show,
  onHide,
  title,
  titleClassName = 'p-4 pb-0',
  titleStyle = CONTENT_COLUMN,
  bodyClassName = 'text-center',
  bodyStyle = CONTENT_COLUMN,
  onExited,
  scrollable = false,
}: CommonLargeModalProps) => (
  <Modal
    show={show}
    onHide={onHide}
    onExited={onExited}
    centered
    scrollable={scrollable}
    size="lg"
  >
    {title && (
      <Modal.Header className="pb-0 border-0" style={titleStyle}>
        <Modal.Title className={clsx(titleClassName, 'w-100 text-center')}>{title}</Modal.Title>
      </Modal.Header>
    )}
    <Modal.Body className={clsx('p-4', bodyClassName)} style={bodyStyle}>
      {children}
    </Modal.Body>
  </Modal>
);

export default CommonLargeModal;
